import { View, StyleSheet } from 'react-native';
import Svg, { Defs, Line, Pattern, Rect } from 'react-native-svg';
import { useThemeColors } from '../hooks/useThemeColors';

export function DiagonalOverlay() {
  const theme = useThemeColors();
  return (
    <View style={StyleSheet.absoluteFill} pointerEvents="none">
      <Svg width="100%" height="100%" style={StyleSheet.absoluteFill}>
        <Defs>
          <Pattern id="diagonal" width={10} height={10} patternUnits="userSpaceOnUse">
            <Line x1={0} y1={0} x2={10} y2={10} stroke={theme.diagonalOverlayStripe} strokeWidth={1} />
          </Pattern>
        </Defs>
        <Rect width="100%" height="100%" fill="url(#diagonal)" />
      </Svg>
    </View>
  );
}
